'use client'

import { PropsWithChildren } from 'react'

import { ErrorBoundary } from '@marketplace-web/error-display/error-display-util'

import { incrementPageLoadCounter, logItemPageError } from '../utils/observability'
import ErrorModal from './ErrorModal'

const ItemPageErrorBoundary = (props: PropsWithChildren<unknown>) => {
  const trackBoundaryError = (boundaryError: Error | null) => {
    incrementPageLoadCounter('failed')
    logItemPageError(boundaryError)
  }

  return (
    <ErrorBoundary onError={trackBoundaryError} FallbackComponent={ErrorModal}>
      {props.children}
    </ErrorBoundary>
  )
}

export default ItemPageErrorBoundary
